
































































import { defineComponent, reactive, SetupContext, toRef, toRefs, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";

interface School {
  id: number;
  name: string;
  teacher_count: number;
}

interface SchoolListData {
  currentUser: any;
  schools: School[];
  errors: string[];
  condition: {
    name: string,
  };
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<SchoolListData>({
      currentUser: context.root.$store.state.currentUser,
      schools: [],
      errors: [],
      condition: {
        name: ""
      }
    });


    /******************************
     * methods
     ******************************/

    /**
     * 学校一覧検索処理
     */
    const searchSchools = async (): Promise<void> => {

      context.root.$store.dispatch("showOverlay", `データ取得中... しばらくお待ちください。`);

      state.errors = [];
  
      await http.get(`/api/teacher/school_list?${Common.BuildQuery(state.condition, 'search_school')}`).then(response => {

        // 検索結果設定
        state.schools = response.data.schools;
      })
      .catch(error => {

        if (error.response.status == 422) {
          state.errors = error.response.data.errors;
        } else {
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /**
     * 学校削除処理
     */
    const deleteSchool = async (id: Number): Promise<void> => {

      if (!confirm(`本当に削除してよろしいでしょうか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.delete(`/api/teacher/school_list/${id}`).then(response => {
        alert(`削除処理が完了しました。`);

        searchSchools();
      })
      .catch(error => {

        if (error.response.status == 422) {
          state.errors = error.response.data.errors;
        } else {
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    const to = (path: string, query: {[key: string]: string}): void => {

      if (query == null) {
        context.root.$router.push({path: path}).catch(err => {});
      } else {
        context.root.$router.push({path: path, query: query}).catch(error => {});
      }
    }


    /******************************
     * created
     ******************************/
    
    searchSchools();

    /******************************
     * watch
     ******************************/


    return {
      ...toRefs(state),
      searchSchools,
      deleteSchool,
      to,
    };
  },
})
